/**
 * Session store — session_id + profile.
 * Profile default null (defense-in-depth con backend GUARD-03).
 */
import { create } from 'zustand'
import type { ProfileType } from '../types/profile'

interface SessionStore {
  session_id: string | null
  profile: ProfileType | null
  setSessionId: (id: string) => void
  setProfile: (p: ProfileType | null) => void
  clear: () => void
}

export const useSessionStore = create<SessionStore>((set) => ({
  session_id: null,
  profile: null,
  setSessionId: (id) => set({ session_id: id }),
  setProfile: (p) => set({ profile: p }),
  clear: () => set({ session_id: null, profile: null }),
}))
